import { normalizeLocale } from "./locale";
import type { MaterialId } from "./materials";
import type { NavSectionId } from "./navigationTypes";

export type NavRouteId = NavSectionId;

export function getSectionRoute(locale: string | undefined, section: NavRouteId): string {
  const resolvedLocale = normalizeLocale(locale);
  if (section === "home") {
    return `/${resolvedLocale}`;
  }
  if (section === "talks-workshops") {
    return `/${resolvedLocale}/talks-workshops/team-lead-series`;
  }
  if (section === "thinking") {
    return `/${resolvedLocale}/thinking/white-papers`;
  }
  return `/${resolvedLocale}/${section}`;
}

export function getThinkingWhitePapersRoute(locale: string | undefined): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/thinking/white-papers`;
}

export function getThinkingWhitePaperRoute(locale: string | undefined, slug: string): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/thinking/white-papers/${slug}`;
}

export function getThinkingLinkedInRoute(locale: string | undefined): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/thinking/linkedin`;
}

export function getThinkingIdeasPostsRoute(locale: string | undefined): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/thinking/ideas-posts`;
}

export function getThinkingGitHubRoute(locale: string | undefined): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/thinking/github`;
}

export function getThinkingResourcesRoute(locale: string | undefined): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/thinking/resources`;
}

export function getThinkingResourceRoute(locale: string | undefined, resource: string): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/thinking/resources/${resource}`;
}

// Legacy insights routes for backward compatibility.
export function getInsightsArticlesRoute(locale: string | undefined): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/insights/articles`;
}

export function getInsightsPostsRoute(locale: string | undefined): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/insights/posts`;
}

export function getInsightsArticleRoute(locale: string | undefined, article: string): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/insights/articles/${article}`;
}

export function getMaterialRoute(locale: string | undefined, material: MaterialId): string {
  const resolvedLocale = normalizeLocale(locale);
  return `/${resolvedLocale}/materials/${material}`;
}
